import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c4c024a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dx-card card-container" }
const _hoisted_2 = { class: "title-container" }


export default /*#__PURE__*/_defineComponent({
  __name: 'info-card-title',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default: ''
   */
  title: {
    type: String,
    default: "",
  },
  /**
   * The width of the component, defined as a string.
   * @type {string}
   * @default '100%'
   */
  width: {
    type: String,
    default: "100%",
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "332d3360": (__props.width)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", null, _toDisplayString(__props.title), 1)
    ])
  ]))
}
}

})